module.exports = __webpack_public_path__ + "img/diamond.c1b55e94.svg";